import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FixedMapleAssistant = () => {
  // Product logic derived from sitemap and index metadata
  const productData = {
    "AI-powered MCTEMS": {
      title: "AI-powered MCTEMS",
      description:
        "MapleCloud's Enterprise Management Solution powered by NMS + ITSM, bringing together operational visibility and service workflows in one platform.",
      whatsapp: "https://wa.me/918178803636",
    },
    EventShield: {
      title: "EventShield",
      description:
        "Advanced AI-SecOps protection platform built for enterprise security, threat detection, and automated operations.",
      whatsapp: "https://wa.me/918178803636",
    },
    "MCT NMS": {
      title: "MCT NMS",
      description:
        "Enterprise-grade Network Monitoring System providing real-time visibility into infrastructure health and performance.",
      whatsapp: "https://wa.me/918178803636",
    },
    MCTZyntra: {
      title: "MCTZyntra",
      description:
        "Zero trust access and secure identity management platform designed for modern business workflows.",
      whatsapp: "https://wa.me/918178803636",
    },
    MapleDoc: {
      title: "MapleDoc",
      description:
        "Secure enterprise document management and automation system for streamlined collaboration.",
      whatsapp: "https://wa.me/918178803636",
    },
    MapleLearn: {
      title: "MapleLearn",
      description:
        "AI-driven corporate learning management platform for enterprise training and knowledge sharing.",
      whatsapp: "https://wa.me/918178803636",
    },
    MCTHRMS: {
      title: "MCTHRMS",
      description:
        "Integrated Human Resource Management System for end-to-end employee lifecycle and payroll automation.",
      whatsapp: "https://wa.me/918178803636",
    },
  };

  const [isOpen, setIsOpen] = useState(false);
  const [activeProduct, setActiveProduct] = useState(
    productData["AI-powered MCTEMS"],
  );
  const scrollRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      scrollRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [activeProduct, isOpen]);

  const navigate = useNavigate();

  return (
    <div className="fixed bottom-4 left-2 z-[9999] font-sans">
      {/* Floating Toggle Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="w-14 h-14 bg-cyan-600 shadow-xl rounded-full shadow-2xl flex items-center justify-center text-white hover:bg-cyan-700 transition-all hover:scale-110 active:scale-95"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
            />
          </svg>
        </button>
      )}

      {/* Fixed Chat Container (Matches Image UI) */}
      {isOpen && (
        <div className="w-[360px] sm:w-[400px] h-[500px] bg-[#0A1221] rounded-2xl shadow-2xl flex flex-col border border-white/10 overflow-hidden animate-in zoom-in-95 duration-200 origin-bottom-right">
          {/* Header */}
          <div className="p-5 bg-[#0A1221] border-b border-white/10 flex justify-between items-center">
            <div>
              <h3 className="text-lg font-bold text-white leading-tight">
                MapleCloud Assistant
              </h3>
              <p className="text-gray-400 text-xs mt-1">
                Explore products or connect with sales.
              </p>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="text-gray-400 hover:text-white p-1"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Interactive Area */}
          <div className="flex-1 overflow-y-auto p-4 custom-scrollbar bg-[#0E1729]">
            <div className="mb-4">
              <span className="text-gray-400 text-[13px] font-medium">
                Choose a product to learn more:
              </span>

              {/* Product Pills */}
              <div className="flex flex-wrap gap-1.5 mt-3 mb-6">
                {Object.keys(productData).map((name) => (
                  <button
                    key={name}
                    onClick={() => setActiveProduct(productData[name])}
                    className={`px-3 py-1.5 rounded-full text-[11px] font-bold transition-all border ${
                      activeProduct.title === name
                        ? "bg-blue-600 border-blue-500 text-white shadow-lg"
                        : "bg-[#1A2642] border-white/5 text-gray-400 hover:text-white"
                    }`}
                  >
                    {name}
                  </button>
                ))}
              </div>

              {/* Dynamic Detail Section */}
              <div className="space-y-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
                <div className="w-full h-px bg-white/5" />
                <h4 className="text-md font-bold text-white tracking-wide">
                  {activeProduct.title}
                </h4>
                <p className="text-gray-300 text-sm leading-relaxed">
                  {activeProduct.description}
                </p>

                {/* Call to Action Buttons */}
                <div className="flex flex-col gap-2.5 pt-2">
                  <div className="flex gap-2">
                    <a
                      href={`https://api.whatsapp.com/send/?phone=918178803636&text=Hello+MapleCloud+team&type=phone_number&app_absent=0`}
                      target="_blank"
                      rel="noreferrer"
                      className="flex-1 py-2.5 bg-[#22C55E] text-white rounded-full text-[13px] font-extrabold flex items-center justify-center hover:brightness-110 transition"
                    >
                      WhatsApp
                    </a>
                    <button onClick={() => navigate('/contactpage')} className="flex-1 py-2.5 bg-[#2563EB] text-white rounded-full text-[13px] font-extrabold flex items-center justify-center hover:brightness-110 transition">
                      Request Demo
                    </button>
                  </div>
                
                </div>
              </div>
              <div ref={scrollRef} />
            </div>
          </div>

          {/* Input Simulator */}
          <div className="p-4 bg-[#0A1221] border-t border-white/10">
            <div className="text-gray-500 text-xs font-light italic">
              other
              <span className="animate-pulse border-l border-gray-400 ml-1 h-3 inline-block"></span>
            </div>
          </div>
        </div>
      )}

      <style
        dangerouslySetInnerHTML={{
          __html: `
        .custom-scrollbar::-webkit-scrollbar { width: 4px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #1A2642; border-radius: 10px; }
      `,
        }}
      />
    </div>
  );
};

export default FixedMapleAssistant;
